import HeroSection from "./hero";
import DescriptionSection from "./description";
import { ChatBtn } from "../chat-btn";
export function TeamPage() {
  return (
    <main class="relative w-full h-full">
      <HeroSection />
      <DescriptionSection />
      <ChatBtn />
    </main>
  );
}
